import { useAccountsId } from "@rentablo/api/apiv1";
import { useCurrencyDisplay } from "@providers/CurrencyDisplayProvider";

export const useDepotInitialCurrency = (depotId?: number) => {
  const { globalCurrency } = useCurrencyDisplay();
  const { data: depot, isPending } = useAccountsId(
    { id: depotId! },
    { enabled: depotId !== undefined }
  );

  return {
    initialCurrency: depot?.currency ?? globalCurrency,
    isLoading: depotId !== undefined && isPending,
  };
};
